{
    "AddNotification": "Adicionar notificação",
    "EditNotification": "Editar notificação",
    "EnableNotification": "Ativar a notificação",
    "DisableNotification": "Desativar a notificação",
    "NotificationNameBusyTime": "Tempo ocupado",
    "NotificationNameAvgAnswerTime": "Tempo médio de resposta (segundos)",
    "NotificationNameUserNotLoggedIn7Days": "Utilizador não registado em 7 dias",
    "NotificationNameMissedCalls": "Chamadas não atendidas (#)",
    "NotificationNameUserNeverLoggedIn": "Nunca entrou no sistema",
    "NotificationNameWeeklyInsightsReport": "Relatório semanal de informações",
    "NAME": "NotificationsLanguage"
}